(ns kyber.subscriptions.core
  (:require [re-frame.core :as re-frame]

            [kyber.subscriptions.async-request :as async-request]
            [kyber.subscriptions.authentication :as authentication]))

(defn initialize-authentication
  []
  (re-frame/reg-sub
   :authentication/is-authenticated?
   authentication/is-authenticated?)

  (re-frame/reg-sub
   :authentication/has-permissions?
   authentication/has-permissions?)

  (re-frame/reg-sub
   :authentication/session-token
   authentication/session-token)

  (re-frame/reg-sub
   :authentication/user-attributes
   authentication/user-attributes)

  (re-frame/reg-sub
   :authentication/has-access?
   authentication/has-access?)

  (re-frame/reg-sub
   :authentication/passwordless-sign-in-email
   authentication/passwordless-sign-in-email)

  (re-frame/reg-sub
   :authentication.activity/idp-integrations
   authentication/activity-idp-integrations))

(def initialize-request async-request/initialize)

(re-frame/reg-sub
 :curriculum-signing/email-sent
 (fn [db _]
   (boolean (:curriculum-signing/email-sent db))))
